import React from 'react';

interface Props {
    children?: React.ReactElement | React.ReactElement[];
    semMargem?: boolean;
    prefixar?: string | React.ReactElement;
    acrescentar?: string | React.ReactElement;
    acrescentarBotao?: React.ReactElement;
    emLinha: boolean;
}

const Grupo = ({ acrescentar, acrescentarBotao, prefixar, children, semMargem, emLinha = false }: Props): React.ReactElement =>
{
    return (
        <div className={`input-group position-relative ${!semMargem && 'mb-3'}`}>
            { prefixar && (
                <span className="input-group-text">
                    { prefixar }
                </span>
            ) }
            <div className={ !emLinha ? 'form-floating form-floating-group' : 'flex-grow-1' }>
                { children }
            </div>
            { acrescentar && (
                <span className="input-group-text">
                    { acrescentar }
                </span>
            ) }
            { acrescentarBotao }
        </div>
    );
}

export default Grupo;
